export const routes = {
    dashboard: {
        path: "dashboard",
    },
    settings: {
        path: "settings",
    },
    onboarding: {
        path: "onboarding",
    },
    schemadashboard: {
        path: "wpsp_schema_dashboard_url",
    }
}